"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.select = exports.setSelection = exports.moveSelection = exports.drawAll = exports.close = exports.open = exports.isOpen = exports.getActions = exports.get = void 0;
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
require("../anims/rogueAanimManager-sidecar");
var rogueSpellData_sidecar_1 = require("../anims/rogueSpellData-sidecar");
var rogueInput_1 = require("../input/rogueInput");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueHotkeys_sidecar_1 = require("../monofont/rogueHotkeys-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueCursor_1 = require("./rogueCursor");
var rogueCursor_sidecar_1 = require("./rogueCursor-sidecar");
var rogueStats_sidecar_1 = require("./rogueStats-sidecar");
require("./rogueUiUpgrades-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
            highlighted: 0,
        };
    }
    return _obj;
};
exports.get = get;
var getActions = function () {
    // _obj.items.push({
    //   name: `Waterbolt`,
    //   letter: 'b',
    //   action: () => {
    //     rogueCursor.setTargetMode(ERogueTargetMode.waterbolt)
    //   },
    // })
    // _obj.items.push({
    //   name: `Waterball`,
    //   letter: 'f',
    //   action: () => {
    //     rogueCursor.setTargetMode(ERogueTargetMode.waterball)
    //   },
    // })
    // _obj.items.push({
    //   name: `Cone of Water`,
    //   letter: 'c',
    //   action: () => {
    //     rogueCursor.setTargetMode(ERogueTargetMode.coneOfWater)
    //   },
    // })
    // _obj.items.push({
    //   name: `Water Blast`,
    //   letter: 'w',
    //   action: () => {
    //     rogueCursor.setTargetMode(ERogueTargetMode.waterBlast)
    //   },
    // })
    // _obj.items.push({
    //   name: `Water Hands`,
    //   letter: 'h',
    //   action: () => {
    //     rogueStats.castWaterHands()
    //   },
    // })
    // _obj.items.push({
    //   name: `Ice Armor`,
    //   letter: 'i',
    //   action: () => {
    //     rogueStats.castIceArmor()
    //   },
    // })
    // _obj.items.push({
    //   name: `Teleport`,
    //   letter: 't',
    //   action: () => {
    //     rogueCursor.setTargetMode(ERogueTargetMode.teleport)
    //   },
    // })
    // _obj.items.push({
    //   name: `Kinetic Rock`,
    //   letter: 'r',
    //   action: () => {
    //     rogueCursor.setTargetMode(ERogueTargetMode.kineticRock)
    //   },
    // })
    var items = [];
    var spells = rogueSpellData_sidecar_1.rogueSpellData.get();
    var _loop_1 = function (i) {
        var spell = spells[i];
        if (!spell.isBought) {
            return "continue";
        }
        if (spell.castType !== 'target' && spell.castType !== 'self') {
            return "continue";
        }
        items.push({
            name: spell.usesLeft + ' ' + spell.name,
            letter: spell.hotkey,
            action: function () {
                if (spell.usesLeft > 0) {
                    spell.usesLeft--;
                    if (spell.castType === 'target') {
                        rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_1.ERogueTargetMode.spellTarget, spell);
                    }
                    if (spell.selfCast) {
                        spell.selfCast();
                    }
                }
                else {
                    rogueStats_sidecar_1.rogueStats.setMessage('Fizzle! No more charges of ' + spell.name);
                }
            },
        });
    };
    for (var i = 0; i < spells.length; i++) {
        _loop_1(i);
    }
    items.push({
        name: "Get more spells",
        letter: 'u',
        action: function () {
            (0, exports.close)();
            // rogueUiUpgrades.open()
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openUpgradesMenu);
        },
    });
    items.push({
        name: "Look",
        letter: 'l',
        action: function () {
            rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_1.ERogueTargetMode.look);
        },
    });
    return items;
};
exports.getActions = getActions;
var isOpen = function () {
    return (0, exports.get)().isOpen;
};
exports.isOpen = isOpen;
var open = function () {
    var obj = (0, exports.get)();
    obj.isOpen = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
    rogueHotkeys_sidecar_1.rogueHotkeys.clearAll();
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    (0, exports.moveSelection)(0, 0); // Reset wrap
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Cast a Spell', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
    // y++
    var items = (0, exports.getActions)();
    var _loop_2 = function (i) {
        var item = items[i];
        y++;
        var isHighlighted = i === obj.highlighted;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') + item.letter + ':' + item.name, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            (0, exports.setSelection)(i);
            (0, exports.select)();
        }, function () {
            (0, exports.setSelection)(i);
        }, item.letter);
    };
    for (var i = 0; i < items.length; i++) {
        _loop_2(i);
    }
};
exports.drawAll = drawAll;
var moveSelection = function (oy, ox) {
    var obj = (0, exports.get)();
    (0, exports.setSelection)(obj.highlighted + oy);
};
exports.moveSelection = moveSelection;
var setSelection = function (selIdx) {
    var obj = (0, exports.get)();
    obj.highlighted = selIdx;
    // Wrap
    var items = (0, exports.getActions)();
    obj.highlighted = mathUtils_sidecar_1.mathUtils.betterMod(obj.highlighted, items.length);
};
exports.setSelection = setSelection;
var select = function () {
    var obj = (0, exports.get)();
    var items = (0, exports.getActions)();
    var item = items[obj.highlighted];
    if (item.action) {
        item.action();
    }
    if (item.command) {
        rogueInput_sidecar_1.rogueInput.setNextInputCommand(item.command);
    }
    (0, exports.close)();
};
exports.select = select;
var cancel = function () {
    (0, exports.close)();
};
exports.cancel = cancel;
